export default "/assets/images/turn-on-mila-app.e6cd9ce177703f35.png";